import { deepMerge } from 'js/utils/Utils'

import { roundEx } from 'js/utils/Maths'

import EventHandler from 'js/modules/_base/events/helper/EventHandler'
import Common from 'js/_core/Common'

const defaults = {
  breakPoint: 767,
}

export default class Resize extends EventHandler {
  constructor(options = {}) {
    super()

    this.devicePc = true
    this.pixelRatio = window.devicePixelRatio
    this.mobileLayout = null
    this.handler = []
    this.event = {
      resize: this._onResize.bind(this),
      resizeObserver: this._onResizeObserver.bind(this),
    }

    this.size = {
      window: {
        x: 0,
        y: 0,
        ratioX: 0,
        ratioY: 0,
      },
      body: {
        x: 0,
        y: 0,
        ratioX: 0,
        ratioY: 0,
      },
    }
    this.aspect = {
      window: {
        xy: 0,
        yx: 0,
      },
      body: {
        xy: 0,
        yx: 0,
      },
    }
    this.prevSize = {
      body: {
        x: 0,
      },
    }
    this.firstViewSize = {
      window: {
        x: 0,
        y: 0,
      },
    }
    deepMerge(this, defaults, options)
  }

  _setVar() {
    const vw = roundEx(document.documentElement.getBoundingClientRect().width * 0.01, 10000)
    // const vw = roundEx(document.body.clientWidth * 0.01, 10000)
    document.documentElement.style.setProperty('--vw', `${vw}px`)
    const vh = roundEx(this.size.window.y * 0.01, 10000)
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  init() {
    this.devicePc = !Common.detection.isMobileDevice && !Common.detection.isTabletDevice

    this._setSize()
    this._setPrevSize()
    this._setFirstViewSize()
    this._setVar()

    this.mobileLayout = this._isMobileLayout()
    this._addEventListeners()
  }

  destroy() {
    this.handler = []
    this._removeEventListeners()
  }

  _onResize() {
    requestAnimationFrame(() => {
      if (this._isChangedDevicePixelRatio()) {
        window.location.reload()
      }

      this._setSize()
      if (this._isChangedLayout()) {
        window.location.reload()
      }
      if (!this.devicePc) {
        if (this.prevSize.body.x === this.size.body.x) {
          return
        }

        if (this.prevSize.body.x !== this.size.body.x) {
          this.firstViewSize.window.y = window.innerHeight

          if (Common.isPageTransitioning) {
            window.location.reload()
          }
        }
      } else {
        if (Common.isPageTransitioning) {
          window.location.reload()
        }
      }

      this._setPrevSize()
    })
  }

  _onResizeObserver() {
    requestAnimationFrame(() => {
      this._setSize()

      this._setVar()
      this._resizeHandler()
    })
  }

  _addEventListeners() {
    window.addEventListener('resize', this.event.resize, false)
    this.resizeObserver = new ResizeObserver(this.event.resizeObserver)
    this.resizeObserver.observe(document.body)
  }

  _removeEventListeners() {
    window.removeEventListener('resize', this.event.resize, false)
    this.resizeObserver.unobserve(document.body)
  }

  _resizeHandler() {
    this.handler.forEach((item) => {
      item.task(this.size, this.aspect)
    })
  }

  _setSize() {
    this.size.window.x = window.innerWidth
    this.size.window.y = window.innerHeight

    this.size.window.ratioX = 1 / this.size.window.x
    this.size.window.ratioY = 1 / this.size.window.y

    this.aspect.window.xy = this.size.window.x / this.size.window.y
    this.aspect.window.yx = this.size.window.y / this.size.window.x

    document.body.style.width = '100%'
    this.size.body.x = document.body.clientWidth
    this.size.body.y = document.body.clientHeight
    document.body.style.width = ''

    this.size.body.ratioX = 1 / this.size.body.x
    this.size.body.ratioY = 1 / this.size.body.y

    this.aspect.body.xy = this.size.body.x / this.size.body.y
    this.aspect.body.yx = this.size.body.y / this.size.body.x
  }

  _setPrevSize() {
    this.prevSize.body.x = this.size.body.x
  }

  _setFirstViewSize() {
    this.firstViewSize.window.y = this.size.window.y
  }

  _isChangedDevicePixelRatio() {
    return this.pixelRatio !== window.devicePixelRatio
  }

  _isChangedLayout() {
    if (this.mobileLayout) {
      return this.size.body.x >= this.breakPoint
    } else {
      return this.size.body.x < this.breakPoint
    }
  }

  _isMobileLayout() {
    return this.breakPoint > this.size.body.x
  }
}